import { render, staticRenderFns } from "./AddressPage.vue?vue&type=template&id=8561e982&scoped=true"
import script from "./AddressPage.vue?vue&type=script&lang=js"
export * from "./AddressPage.vue?vue&type=script&lang=js"
import style0 from "./AddressPage.vue?vue&type=style&index=0&id=8561e982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8561e982",
  null
  
)

export default component.exports